module.exports = __webpack_public_path__ + "img/williams.903fd5a3.png";